import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="hero" data-testid="hero-section">
      <div className="hero-background">
        <div className="hero-gradient"></div>
      </div>
      
      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-badge" data-testid="hero-badge">
            <Sparkles size={16} />
            <span>AI That Never Sleeps</span>
          </div>

          <h1 className="hero-title" data-testid="hero-title">
            Automate Your Business with
            <span className="hero-highlight"> AI That Never Sleeps</span>
          </h1>

          <p className="hero-subtitle" data-testid="hero-subtitle">
            DanstonAI builds intelligent AI software for every industry — designed to fully automate daily operations, reduce manpower costs, and transform the way businesses work.
          </p>

          <div className="hero-cta">
            <button 
              className="btn-primary hero-btn"
              data-testid="hero-cta-primary"
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            >
              Book a Demo
              <ArrowRight size={20} style={{ marginLeft: '8px' }} />
            </button>
            <button 
              className="btn-secondary hero-btn"
              data-testid="hero-cta-secondary"
              onClick={() => document.getElementById('solutions').scrollIntoView({ behavior: 'smooth' })}
            >
              Talk to Our AI Experts
            </button>
          </div>
        </div>
      </div>

      <div className="scroll-indicator" data-testid="scroll-indicator">
        <motion.div
          className="scroll-arrow"
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          ↓
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
